import React, { useMemo, useRef, useState } from 'react'
import { Block, CRRender } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'
import ImgPopup from '@/components/popups/imgPopup'
import placeholderImg from '@/assets/images/Not_available.jpg'
import ActionBtn from '@/components/ActionBtn'
const APLINK = window.API_URL

const Gallery = ({ galleryImages }) => {


    const refImg = useRef(null)
    const [image, setImage] = useState("")

    const [isShowMoreImages, setIsShowMoreImages] = useState(false)

    const handleClick = (image) => {
        setImage(image)
        refImg.current.click()
    }


    const GalleryImg = useMemo(() => {

        let galleryImgs = galleryImages?.find(image => image.name == "GalleryImgs")?.data
        return !!galleryImgs?.length ? galleryImgs : []
    }, [])


    return (
        <Block isRender={galleryImages?.filter(image => image.name == "GalleryImgs")?.length > 0}>
            <SectionCard icon="mdi:image-multiple" titleKey="gallery">
                <div className="gallery-grid">
                    {GalleryImg?.slice(0, isShowMoreImages ? GalleryImg?.length : 4)?.mapWithKey((image) => (
                        <div className="gallery-item" key={image.name}  >
                            <img
                                src={`${APLINK}${image.name}`}
                                alt={image.name}
                                className="gallery-image"
                                onError={(e) => e.target.src = placeholderImg}
                                onClick={(action) => handleClick(image.name)}
                            />
                        </div>
                    ))}
                </div>
            </SectionCard>
            <ImgPopup sourcePath={APLINK} link={`${image}`} isHideText={true} refImg={refImg} />

            <Block isRender={GalleryImg?.length > 4}>
                <br />
                <CRRender isRender={isShowMoreImages}>
                    <ActionBtn title={"show-less"} icon={"mdi:chevron-up"} onApply={() => setIsShowMoreImages(prev => false)} />
                </CRRender>

                <CRRender isRender={!isShowMoreImages}>
                    <ActionBtn title={"show-more"} icon={"mdi:chevron-down"} onApply={() => setIsShowMoreImages(prev => true)} />
                </CRRender>
            </Block>
        </Block>
    )
}

export default Gallery

